import React from 'react'
import './timeline-card.css'
import SlideShow from "../SlideShow/SlideShow";

const TimelineCard = (props) => {
    const { title, text, date, images, index, isActive, onHover, onLeave, totalItems } = props;

    const isEven = index % 2 === 0;
    const cardClassName = `modern-timeline-card ${isEven ? 'card-left' : 'card-right'} ${isActive ? 'card-active' : ''}`;

    return (
        <div
            className={cardClassName}
            onMouseEnter={onHover}
            onMouseLeave={onLeave}
        >
            <div className="timeline-node">
                <div className="timeline-dot">
                    <div className="timeline-dot-inner"></div>
                </div>
            </div>

            <div className="timeline-card-content">
                <div className="card-header">
                    <span className="timeline-date">{date}</span>
                    <div className="card-progress">
                        <div className="progress-indicator">
                            {index + 1} / {totalItems}
                        </div>
                    </div>
                </div>

                <div className="card-body">
                    <h4 className="timeline-title">{title}</h4>
                    <div className="timeline-description">{text}</div>

                    {images && (
                        <div className="timeline-images">
                            <SlideShow images={images}/>
                        </div>
                    )}
                </div>

                <div className="card-connector">
                    <div className="connector-line"></div>
                </div>
            </div>
        </div>
    )
}

export default TimelineCard
